import { isExpEditor } from '../lib/lib'
import Swiper from 'swiper/bundle'

class stepsSwiper {
  constructor(element) {
    if (!element) {
      return false
    }

    if (isExpEditor()) {
      return false
    }

    this.$strip = jQuery(element)
    this.$swiper = this.$strip.find('.swiper')[0]

    setTimeout(() => {
      new Swiper(this.$swiper, {
        slidesPerView: 1,
        spaceBetween: 8,

        navigation: {
          prevEl: this.$strip.find('.swiper-button-prev')[0],
          nextEl: this.$strip.find('.swiper-button-next')[0],
        },
      })
    }, 2000)
  }
}

export default stepsSwiper
